<template>
    <modal-side-filters
    :subTitle="t('agencies.filterModal.subTitle')"
    :showButtons="showFooterHandler"
    :triggerClose="triggerClose"
    @clearFilters="clearFiltersHandler"
    @hideMe="[triggerClose = false, emit('hideMe')]"
    @applyFilters="applyFiltersHandler">
        <div :class="{'mobile-styles': getMobileAppState}">
            <!-- Provinces Dropdown -->
            <dropdown-generic
            class="filter-input"
            :params="{
                labelText: t('agencies.filterModal.province'),
                mobileTitle: t('agencies.filterModal.province'),
                placeholder: t('agencies.filterModal.provincePlaceholder')
            }"
            :options="provincesDropdownOptions"
            :selectedOption="modalFilters.agenciesProvince"
            @clicked="modalFilters.agenciesProvince = $event"/>
        </div>
    </modal-side-filters>
</template>

<script setup>
import ModalSideFilters from '@/components/generic/modals/side/Filters'
import DropdownGeneric from '@/components/generic/dropdowns/generic/Generic'

/* Vue & Helpers */
import { ref, computed } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getAgenciesProvincesList } = mapGetters(moduleMapper.AGENCIES)
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['hideMe', 'applyFilters'])

const props = defineProps({
    appliedFilters: Object
})

/*************************************************
 *                                                *
 *                     Modal                      *
 *                                                *
 *************************************************/
const triggerClose = ref(false)

const provincesDropdownOptions = computed(() => {
    return getAgenciesProvincesList.value.map(province => {
        return {
            id: province,
            text: province
        }
    })
})
const modalFilters = ref({
    agenciesProvince: props.appliedFilters.agenciesProvince
})

const applyFiltersHandler = () => {
    triggerClose.value = true
    emit('applyFilters', modalFilters.value)
}

const clearFiltersHandler = () => {
    for (const filter in modalFilters.value) {
        modalFilters.value[filter] = ''
    }
}

const showFooterHandler = computed(() => {
    const { agenciesProvince } = modalFilters.value

    const emptyFields = Object.values(modalFilters.value).every(field => field === null || field === '')
    const hasAppliedFilters = Object.values(props.appliedFilters).some(filter => filter !== '')
    const filtersChanged = agenciesProvince !== props.appliedFilters.agenciesProvince

    return !emptyFields || hasAppliedFilters || filtersChanged
})
</script>

<style lang="scss" scoped>
.mobile-styles {
    padding: 0 16px 16px 16px;
}
</style>
